import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinBulkRoute: InvariantJiraRoute = {
	name: 'legacy-gin-bulk',
	path: '/secure/Bulk(\\w+)([!%]?[\\w]*).jspa',
};
